import axios from 'axios'
import { genURL } from "../../_getjson";

export default async function ChackAp(code) {
    if (code) {
        let rs, rs1, rs2, rs3 = ""
        let Url = "CSAP/APCode?apcode=" + code;
        console.log(genURL(Url));
        await axios.get(genURL(Url), { timeout: 1800 }).then((res) => {
            if (res.data.length > 0) {
                rs = res.data[0].APNAME
                rs1 = res.data[0].CREDITCODE
                rs2 = res.data[0].TAXTYPE
                rs3 = rs + "|" + rs1 + "|" + rs2
            }
        }).catch((err) => {
            console.log(err);
        });
        return rs3
    }
};